function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M73.5 38.5C73.5 57.925 60.06 76.09 42 80.5C23.94 76.09 10.5 57.925 10.5 38.5V17.5L42 3.5L73.5 17.5V38.5ZM42 73.5C55.125 70 66.5 54.39 66.5 39.27V22.05L42 11.13L17.5 22.05V39.27C17.5 54.39 28.875 70 42 73.5ZM52.675 56L41.895 49.525L31.15 56L33.985 43.75L24.5 35.56L37.03 34.475L41.895 22.925L46.795 34.44L59.325 35.525L49.805 43.75L52.675 56Z",
  fill: "#666666"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.895 49.525L52.675 56L49.805 43.75L59.325 35.525L46.795 34.44L41.895 22.925L37.03 34.475L24.5 35.56L33.985 43.75L31.15 56L41.895 49.525Z",
  fill: "#666666"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3001 50.241L53.0164 57.3125L49.9072 43.9848L60.2585 35.0175L46.6274 33.842L41.3001 21.2916L35.9728 33.842L22.3418 35.0175L32.6741 43.9848L29.5839 57.3125L41.3001 50.241Z",
  fill: "#FF6600"
});

function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.3d962db2.svg";
export { ForwardRef as ReactComponent };